
<div class="section-container">
  <div class="websites-column">
    <ng-container *ngFor="let cat of linkCategories">
      <div class="website-category">
        <h2 class = "mat-display-small">{{ cat.name }}</h2>

      <div class="website-row" *ngFor="let link of cat.links">
        <div class="website-image">
          <div class="website-image-container">
          <img *ngIf="link.image"
               [ngSrc]="link.image"
               [alt]="link.label + ' logo'"
               fill
               class = "logo"
              />
        </div>
        </div>
        <div class="website-text">
          <a [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
          <p *ngIf="link.description">{{ link.description }}</p>
        </div>
      </div>
      </div>
    </ng-container>
  </div>
</div>

